<aside class="aside">
    <cm-profile-card
        [profile]="profile"
        [canUpdateAvatar]="profile.role_id === ROLE_CODES.PROFESSIONAL"
        class="profile-card"
    ></cm-profile-card>
    <cm-side-menu *ngIf="links.length" [links]="links"></cm-side-menu>
</aside>
<main class="main"><router-outlet></router-outlet></main>
